// extracted by mini-css-extract-plugin
export default {"nav":"back_nav__sCNWW","link":"back_link__uiXhJ","link__chevron":"back_link__chevron__H78ll","link__text":"back_link__text__pdMa3"};